import * as React from 'react'

import styled, { keyframes } from 'style/styled-components'

const rotation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Loader = styled.div`
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #5BC2E7;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: ${rotation} 2s linear infinite;
  margin:0 auto;
`

class LoadingPage extends React.Component {
  public render(): JSX.Element {
    return (
      <div className="row justify-content-md-center">
        <div className="col-12 col-md-10 text-center">
          <Loader className="igsWaitMask"/>
        </div>
      </div>
    )
  }
}

export default LoadingPage



// WEBPACK FOOTER //
// ./src/components/creditCheck/loading.tsx